module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAJ1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADdEvm1AAAADXRSTlMA/0Ai5OgbH+AggMJkPMc2igAAAF1JREFUeJxjGAX0AdkFuGTYGt1xSWUIihjg0iQoikMqQ1AweHBrklFCAZoITehACqEJl1QJbil2R5xSDFNwOgOkDZfjQbbh8PKg0oZTit3RGYcMA8PsCTilRgENAACVXhxgb61RUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/返回.png
// module id = 6qIg
// module chunks = 1